import { TextField, Typography, withStyles } from '@material-ui/core';
import Link from 'next/link';

import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'src/app/i18n';
import ClipboardPlayOutline from 'src/assets/icons/common/ClipboardPlayOutline';
import { useHomePageState } from 'src/components-pages/home-page/HomePageProvider';
import { useFloatConsultantStyles } from 'src/components-pages/home-page/styles/index.style';

import { setFooterEmail } from 'src/store/reducer';
import useFooterStyle from '../layouts/styles/footerStyles';
import { MainButton } from './MainButton';

const CssTextField = withStyles({
    root: {
        // maxWidth: 150,
        // opacity: (props: any) => (props.open ? 1 : 0),
        flex: 1,

        '& label.Mui-focused': {
            color: 'white'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'transparent'
        }
    }
})(TextField);

const FooterTypography = withStyles((theme) => ({
    root: {
        opacity: (props: any) => (props.open ? 1 : 0),
        gridColumnEnd: 'span 4',
        marginBottom: theme.spacing(2),
        color: '#FFF',
        [theme.breakpoints.down('xs')]: {
            gridColumnEnd: 'span 1',
            gridRowEnd: 'span 1'
        }
    }
}))((props: any) => <Typography variant="body1" {...props} />);

export const FloatConsultantButton = () => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const classes = useFooterStyle();
    const router = useRouter();
    const [open, setOpen] = useState(true);
    const floatClasses = useFloatConsultantStyles({ open });
    const { page } = useHomePageState();
    useEffect(() => {
        setOpen(false);
    }, [page]);
    return (
        <div className={floatClasses.container}>
            <div>
                <FooterTypography open={open} className={classes.formLabel}>
                    {t('form.requestConsultation')}
                </FooterTypography>
                <div className={floatClasses.emailField}>
                    <CssTextField
                        // open={open}
                        onChange={(e: any) => dispatch(setFooterEmail(e.target.value))}
                        placeholder={t('form.enterEmail')}
                        className={classes.textInput}
                    />

                    <MainButton
                        onClick={() => {
                            if (open) {
                                router.push('/schedule');
                            } else {
                                setOpen(true);
                            }
                        }}
                        className={floatClasses.formButton}
                        textProp={{ variant: 'body1', className: classes.formButtonText }}>
                        {open ? t('action.getStarted') : <ClipboardPlayOutline />}
                    </MainButton>
                </div>
            </div>
        </div>
    );
};
export const ConsultantButton = () => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const classes = useFooterStyle();

    const floatClasses = useFloatConsultantStyles();

    return (
        <div className={floatClasses.emailField}>
            <CssTextField
                onChange={(e: any) => dispatch(setFooterEmail(e.target.value))}
                placeholder={t('form.enterEmail')}
                className={floatClasses.textInput}
                inputProps={{ className: floatClasses.input }}
            />
            <Link href="/schedule">
                <MainButton
                    className={floatClasses.formButton}
                    textProp={{ variant: 'caption', className: classes.formButtonText }}>
                    {t('action.getStarted')}
                </MainButton>
            </Link>
        </div>
    );
};
